import React, { useEffect, useRef } from "react";
import { Button, Card, CardBody, Col, Container, Input, Label, Row, Spinner } from "@/Components/ui";
;
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import moment from "moment";
import { API_SEND_TO_ALL_VOUCHER, API_USERS_CRM, API_VOUCHER, getDataFromUrl } from "../../../api";
import { postData } from "../../../api";
import UserSelectBox from "../../../Components/Common/UserSelectBox";
import toast, { Toaster } from 'react-hot-toast';
import { dialogService } from "@/utils/dialogService";
const SendVoucherCoupon = ({ history }) => {
    const [target, setTarget] = React.useState("user");
    const [userList, setUserList] = React.useState([]);
    const [search, setSearch] = React.useState("");
    const [count, setCount] = React.useState(0);
    const [selectedUsers, setSelectedUsers] = React.useState([]);
    const [isSending, setIsSending] = React.useState(false);
    const [reservationCouponList, setReservationCouponList] = React.useState([]);
    const abortController = useRef(null);
    const [isSendSMS, setIsSendSMS] = React.useState(false);
    const [isBatch, setIsBatch] = React.useState(false);
    const [selectedPreCoupon, setSelectedPreCoupon] = React.useState(0);
    const [voucherCount, setVoucherCount] = React.useState(1);
    useEffect(() => {
        console.log("selectedUsers", selectedUsers);
    }, [selectedUsers]);
    useEffect(() => {
        if (reservationCouponList.length !== 0) {
            const _coupon = reservationCouponList?.find((item) => moment(item["만료일"]) > moment());
            if (_coupon) {
                setSelectedPreCoupon(_coupon.id);
            }
        }
    }, [reservationCouponList]);
    useEffect(() => {
        if (abortController.current) {
            abortController.current.abort();
        }
        if (search) {
            abortController.current = new AbortController();
            getDataFromUrl(`${API_USERS_CRM}/?search=${search}`, abortController.current.signal)
                .then((data) => {
                console.log(data);
                setUserList(data.results);
                setCount(data.count);
            })
                .catch((e) => {
                console.log(e);
            });
        }
    }, [search]);
    const handleSelectedPreCoupon = (e) => {
        setSelectedPreCoupon(e.target.value);
        console.log("selectedPreCoupon", e.target.value);
    };
    useEffect(() => {
        getDataFromUrl(`${API_VOUCHER}/?include_retired=true`)
            .then((data) => {
            setReservationCouponList(data);
            console.log("sendPro", data);
        })
            .catch((e) => {
            console.log(e);
        });
    }, []);
    // 결정 283: 보내는 동안 버튼 막기·진행 표시·완료/오류 문구, 전체는 확인창
    const [sendStatus, setSendStatus] = React.useState("");
    const errText = (e) => e?.response?.data?.error || e?.response?.data?.message || e?.message || "알 수 없는 오류";
    const sendToCustomers = async () => {
        if (isSending) return;
        if (selectedUsers.length === 0) {
            await dialogService.handleAlert("회원을 선택해주세요.");
            return;
        }
        const users = selectedUsers.map((element) => element.id);
        setIsSending(true);
        setSendStatus(`보내는 중… (${users.length}명)`);
        try {
            const data = await postData(`${API_VOUCHER}/send/`, { users, isSendSMS, voucher: selectedPreCoupon, count: voucherCount });
            if (data.status === "ok") {
                const msg = `완료 — ${data.sent}명에게 보냈습니다.` + (data.skipped ? ` (10분 안에 이미 받은 ${data.skipped}명은 건너뜀)` : "");
                setSendStatus(msg);
                toast.success(msg);
                setSelectedUsers([]);
            } else {
                setSendStatus(`실패 — ${data.error || data.message || "알 수 없는 오류"}`);
                toast.error(`실패 — ${data.error || data.message || "알 수 없는 오류"}`);
            }
        } catch (e) {
            setSendStatus(`실패 — ${errText(e)}`);
            toast.error(`실패 — ${errText(e)}`);
        } finally {
            setIsSending(false);
        }
    };
    const sendToAllCustomers = async () => {
        if (isSending) return;
        let total = 0;
        try {
            const info = await getDataFromUrl(`${API_VOUCHER}/send-to-all/info/?voucher=${selectedPreCoupon}`);
            if (info.running) {
                toast.error("전체 발송이 처리 중입니다. 끝난 뒤 다시 시도해 주세요.");
                return;
            }
            total = info.total_users || 0;
        } catch (e) {
            toast.error(`실패 — ${errText(e)}`);
            return;
        }
        if (!window.confirm(`회원 ${total.toLocaleString()}명에게 ${voucherCount}장씩 보냅니다. 계속?`)) return;
        setIsSending(true);
        setSendStatus(`보내는 중… ${total.toLocaleString()}명 중 0명`);
        const timer = setInterval(async () => {
            try {
                const info = await getDataFromUrl(`${API_VOUCHER}/send-to-all/info/?voucher=${selectedPreCoupon}`);
                const pg = info.progress || {};
                if (pg.total) setSendStatus(`보내는 중… ${pg.total.toLocaleString()}명 중 ${(pg.done || 0).toLocaleString()}명`);
            } catch (e) { /* 진행률만 못 받음 */ }
        }, 2000);
        try {
            const data = await postData(API_SEND_TO_ALL_VOUCHER, { isSendSMS, voucher: selectedPreCoupon, count: voucherCount });
            if (data.status === "ok") {
                const msg = `완료 — ${data.sent.toLocaleString()}명에게 보냈습니다.` + (data.skipped ? ` (10분 안에 이미 받은 ${data.skipped.toLocaleString()}명은 건너뜀)` : "");
                setSendStatus(msg);
                toast.success(msg);
            } else {
                setSendStatus(`실패 — ${data.error || data.message || "알 수 없는 오류"}`);
                toast.error(`실패 — ${data.error || data.message || "알 수 없는 오류"}`);
            }
        } catch (e) {
            setSendStatus(`실패 — ${errText(e)}`);
            toast.error(`실패 — ${errText(e)}`);
        } finally {
            clearInterval(timer);
            setIsSending(false);
        }
    };
    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="교환권 보내기" pageTitle="교환권"/>

          <Row className="g-4 mb-3">
            <div className="col-sm-auto">
              <div>
                <h4 className="card-title mb-0 flex-grow-1">교환권 보내기</h4>
              </div>
            </div>
            <div className="col-sm-3 ms-auto">
              <div className="d-flex justify-content-sm-end align-items-center gap-2">
                {sendStatus ? <span className="text-muted small">{sendStatus}</span> : null}
                <Button color="success" className="add-btn me-1" disabled={isSending} onClick={target === "user" ? sendToCustomers : sendToAllCustomers} id="create-btn">
                  {isSending ? (<><Spinner size="sm" className="me-1"/>보내는 중…</>) : "보내기"}
                </Button>
              </div>
            </div>
          </Row>

          <Row>
            <Col xxl={12}>
              <Card>
                <CardBody>
                  <div className="live-preview">
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Input className="form-check-input" type="checkbox" id="isSendSMS" value={isSendSMS} onChange={(e) => setIsSendSMS(e.target.checked)}/>
                          <Label htmlFor="isSendSMS" className="form-check-label">
                            사용자가 알림 허용을 (또는 앱설치를) 안한 경우 문자로 보내기
                          </Label>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="reservationCoupon" className="form-label">
                            교환권 선택
                          </Label>
                          <Input type="select" className="form-control" id="reservationCoupon" placeholder="교환권을 선택해주세요." value={selectedPreCoupon} onChange={handleSelectedPreCoupon}>
                            {reservationCouponList?.map((item, index) => {
            if (moment(item["만료일"]) < moment())
                return null;
            return (<option key={index} value={item.id}>
                                  {item["이름"]} (만료일: {item["만료일"]})
                                </option>);
        })}
                          </Input>
                        </div>
                      </Col>
                    </Row>

                    <Row></Row>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="notificationBody" className="form-label">
                            수량
                          </Label>
                          <Input type="text" className="form-control" id="notificationBody" placeholder="수량을 입력하세요" value={voucherCount} onChange={(e) => setVoucherCount(e.target.value)}/>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="notificationTarget" className="form-label">
                            대상
                          </Label>
                          <Input type="select" className="form-control" id="notificationTarget" placeholder="대상을 선택하세요" value={target} onChange={(e) => setTarget(e.target.value)}>
                            <option value="all">지점 전체 회원</option>
                            <option value="user">회원 선택</option>
                          </Input>
                        </div>
                      </Col>
                    </Row>
                    {target === "user" && (<>
                        <Row>
                          <Col md={12}>
                            <UserSelectBox userList={userList} setUserList={setUserList} selectedUsers={selectedUsers} setSelectedUsers={setSelectedUsers} search={search} setSearch={setSearch} count={count} setCount={setCount}/>
                          </Col>
                        </Row>
                      </>)}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Toaster position="top-center"/>

      </div>
    </React.Fragment>);
};
export default SendVoucherCoupon;
